import React, { useState } from 'react';

export default function LoginTable({ logins, loginAttempts = [] }) {
  const [tab, setTab] = useState('recent');

  const failedAttempts = loginAttempts.filter(a => !a.success);

  return (
    <div className="card" style={{ height: '100%' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
        <h3 style={{ margin: 0, flex: 1 }}>
          {tab === 'recent' ? 'Recent Logins' : 'Failed Logins'}
        </h3>
        <div style={{ display: 'flex', gap: 4 }}>
          <button
            className={`btn-small ${tab === 'recent' ? 'btn-success' : ''}`}
            style={{ fontSize: 11, padding: '4px 8px' }}
            onClick={() => setTab('recent')}
          >
            Recent
          </button>
          <button
            className={`btn-small ${tab === 'failed' ? 'btn-danger' : ''}`}
            style={{ fontSize: 11, padding: '4px 8px', position: 'relative' }}
            onClick={() => setTab('failed')}
          >
            Failed
            {failedAttempts.length > 0 && (
              <span className="badge badge-redeemed" style={{ marginLeft: 4, fontSize: 9 }}>
                {failedAttempts.length}
              </span>
            )}
          </button>
        </div>
      </div>

      {tab === 'recent' ? (
        logins.length === 0 ? (
          <div className="empty-state" style={{ padding: 20 }}>No login records</div>
        ) : (
          <div style={{ maxHeight: 300, overflowY: 'auto' }}>
            <table>
              <thead>
                <tr>
                  <th>User</th>
                  <th>Last Active</th>
                  <th className="hide-mobile">Points</th>
                </tr>
              </thead>
              <tbody>
                {logins.map(l => (
                  <tr key={l.id}>
                    <td>
                      <strong>{l.username}</strong>
                      {l.is_admin && (
                        <span className="badge badge-rare" style={{ marginLeft: 6, fontSize: 9 }}>Admin</span>
                      )}
                    </td>
                    <td style={{ fontSize: 12 }}>{new Date(l.last_login_at).toLocaleString()}</td>
                    <td className="hide-mobile" style={{ color: 'var(--warning)', fontSize: 13 }}>
                      {l.points} BP
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )
      ) : (
        failedAttempts.length === 0 ? (
          <div className="empty-state" style={{ padding: 20 }}>No failed login attempts</div>
        ) : (
          <div style={{ maxHeight: 300, overflowY: 'auto' }}>
            <table>
              <thead>
                <tr>
                  <th>Username</th>
                  <th>IP Address</th>
                  <th>Time</th>
                </tr>
              </thead>
              <tbody>
                {failedAttempts.map(a => (
                  <tr key={a.id}>
                    <td><strong style={{ color: 'var(--danger)' }}>{a.username}</strong></td>
                    <td style={{ fontSize: 12, color: 'var(--text-secondary)' }}>{a.ip_address}</td>
                    <td style={{ fontSize: 12 }}>{new Date(a.attempted_at).toLocaleString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )
      )}
    </div>
  );
}
